import CircularProgress from '@eversports/react-components/primitives/CircularProgress'
import Placeholder from '@eversports/react-components/primitives/Placeholder'
import { assertNever } from '@eversports/utility-types'
import React from 'react'

import useBookingDetails from '../../data/useBookingDetails'

import BookableItemBookingDetailsContent from './common/BookableItemBookingDetailsContent'
import { PrivateSessionDetailsContent } from './common/PrivateSessionDetailsContent'
import InvoiceDetailsContent from './common/InvoiceDetailsContent'
import ProductBookingDetailsContent from './common/ProductBookingDetailsContent'

const MobileBookingDetails: React.FC<React.PropsWithChildren<unknown>> = () => {
  const { bookingDetails, isBookingDetailsLoading } = useBookingDetails()

  if (isBookingDetailsLoading || !bookingDetails) {
    return (
      <Placeholder height={250} width="100%" center>
        <CircularProgress />
      </Placeholder>
    )
  }

  switch (bookingDetails.type) {
    case 'invoice':
      return <InvoiceDetailsContent venue={bookingDetails.venue} invoice={bookingDetails.invoice} />
    case 'product':
      return <ProductBookingDetailsContent venue={bookingDetails.venue} product={bookingDetails.product} />
    case 'bookableItem':
      const eventSessions =
        bookingDetails.settleWith?.__typename === 'Ticket'
          ? bookingDetails.settleWith.validForSessions
          : bookingDetails.bookableItem.__typename === 'EventBookableItem'
            ? bookingDetails.bookableItem.eventSessions
            : undefined

      return (
        <BookableItemBookingDetailsContent
          bookableItem={bookingDetails.bookableItem}
          hasSpotBooking={bookingDetails.hasSpotBooking}
          assignedSpot={bookingDetails.assignedSpot}
          eventSessions={eventSessions}
        />
      )
    case 'privateSession':
      return (
        <PrivateSessionDetailsContent
          bookableItem={bookingDetails.bookableItem}
          trainer={bookingDetails.trainer}
          start={bookingDetails.start}
          end={bookingDetails.end}
          settleWith={bookingDetails.settleWith}
        />
      )
    case 'unsupported':
      throw new Error('Not able to support this booking item')
    default:
      return assertNever(bookingDetails)
  }
}

export default MobileBookingDetails
